export const Color = {
    // Main
    // UI
    teal: '#009B9B',

    inherit: 'inherit',
    // Text
    textMain: '#00130A',
    textSecondary: '#575757',
    textDisabled: '#E4E4E4',

    // Border
    spaceGray: '#C3C5C7',
    spaceGrayHover: '#A9A9A9',

    // Light Gray
    lightGray: '#F7F7F7',
    lightGrayHover: '#EEEEEE',
    lightGrayDisabled: '#FCFCFC',

    // Opacity Sky
    opacitySky: '#F9FAFC',
    opacitySkyHover: '#EDEFF5',

    // Button - Primary
    primary: '#01CDCB',
    primaryHover: '#01B2B0',
    primaryActive: '#01B2B1',
    primaryDisabled: '#D1FAFA',

    // Button - Yellow
    yellow: '#FFAE35',
    yellowHover: '#E29C33',
    yellowActive: '#D89531',
    yellowDisabled: '#EBCA98',

    // Button - Danger
    danger: '#EF8763',
    dangerHover: '#DA7856',
    dangerActive: '#CC7050',
    dangerDisabled: '#F5BCA9',

    // Button - Red
    red: '#C62828',
    redHover: '#D96959',
    redActive: '#CB6051',
    redDisabled: '#FFDCDC',

    // Button - Green Smoke
    greenSmoke: '#DDEAE4',
    greenSmokeHover: '#C6D9D0',
    greenSmokeActive: '#B0CBBE',
    greenSmokeDisabled: '#EEF4F1',
    greenSmokeDisabledText: '#96C1AD',

    // Table Highlights
    tableGreen: '#F3FFEA',
    tableYellow: '#FBF8DF',
    tableRed: '#FEF0EC',
    tableGray: '#F0F2F7',

    // orange
    orangeLight: '#ED6C42',

    // brandColors -primary
    main: '#01CDCB',
    dark: '#00AEAD',
    light: '#CCF5F5',

    // brandColors -accent
    spMainOrange: '#F7632F',
    spMainOrangeD: '#BA3A0D',
    spMainOrangeL: '#FDD1C1',

    // brandColors - secondary
    blackNew: '#121212',
    black: '#041614',
    white: '#FFFFFF',
    // brandColors - gray
    gray300: '#F2F2F2',
    gray500: '#DFE1E0',
    gray700: '#828B89',
    gray900: '#9E9E9E',

    // brandColors - gray-blue
    grayBlue100: '#F8F9FA',
    grayBlue300: '#EDF3F9',
    grayBlue500: '#DBE6F1',
    grayBlue700: '#6A7D90',

    // System colors -  error
    sysRed: '#D40E32',
    sysRedL: '#F7D2D8',

    // System colors - successful
    sysGreen: '#05AA6F',
    sysGreenL: '#D0EFE4',

    // System colors - warning
    sysOrange: '#F0A83C',
    sysOrangeL: '#FDEACD',

    // System colors - information
    sysBlue: '#5FB6E7',
    sysBlueL: '#E1F2FB',
}

export const Colors = {
    brandColors: {
        primary: {
            main: Color.main,
            dark: Color.dark,
            light: Color.light,
        },
        accent: {
            spMainOrange: Color.spMainOrange,
            spMainOrangeD: Color.spMainOrangeD,
            spMainOrangeL: Color.spMainOrangeL,
        },
        secondary: {
            blackNew: Color.blackNew,
            black: Color.black,
            white: Color.white,
        },
        gray: {
            gray300: Color.gray300,
            gray500: Color.gray500,
            gray700: Color.gray700,
        },
        grayBlue: {
            grayBlue100: Color.grayBlue100,
            grayBlue300: Color.grayBlue300,
            grayBlue500: Color.grayBlue500,
            grayBlue700: Color.grayBlue700,
        },
    },
    systemColors: {
        error: {
            sysRed: Color.sysRed,
            sysRedL: Color.sysRedL,
        },
        successful: {
            sysGreen: Color.sysGreen,
            sysGreenL: Color.sysGreenL,
        },
        warning: {
            sysOrange: Color.sysOrange,
            sysOrangeL: Color.sysOrangeL,
        },
        information: {
            sysBlue: Color.sysBlue,
            sysBlueL: Color.sysBlueL,
        },
    },
}